define(["react","prop-types","classnames","underscore","@bingads-webui-react/primitive-unthemed","react-jss","hoist-non-react-statics","@bingads-webui-universal/primitive-utilities","@bingads-webui-react/hoc-utils","@bingads-webui-react/layout"], function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__43__, __WEBPACK_EXTERNAL_MODULE__45__, __WEBPACK_EXTERNAL_MODULE__46__, __WEBPACK_EXTERNAL_MODULE__47__, __WEBPACK_EXTERNAL_MODULE__49__, __WEBPACK_EXTERNAL_MODULE__50__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  version: true,
  CheckboxGroup: true,
  RadioGroup: true
};
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function get() {
    return _package.version;
  }
});
Object.defineProperty(exports, "CheckboxGroup", {
  enumerable: true,
  get: function get() {
    return _checkboxGroup.CheckboxGroup;
  }
});
Object.defineProperty(exports, "RadioGroup", {
  enumerable: true,
  get: function get() {
    return _radioGroup.RadioGroup;
  }
});

var _package = __webpack_require__(41);

var _controls = __webpack_require__(42);

Object.keys(_controls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _controls[key];
    }
  });
});

var _checkboxGroup = __webpack_require__(51);

var _radioGroup = __webpack_require__(52);

/***/ }),
/* 41 */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"@bingads-webui-react/primitive\",\"description\":\"Please find documentation and tutorial at http://bingadsinternal.azurewebsites.net/sharedcomponents/client-react-controls/jsdoc/primitive\",\"version\":\"1.5.24\",\"main\":\"dist/index\",\"license\":\"UNLICENSED\",\"peerDependencies\":{\"hoist-non-react-statics\":\">=3.0.0\",\"prop-types\":\"15.6.0\",\"react\":\"16.3.0\",\"react-dom\":\"16.3.0\",\"react-jss\":\"8.6.1\",\"underscore\":\"1.8.3\",\"classnames\":\">=2.2.6\",\"@bingads-webui-react/hoc-utils\":\">=0.0.1\",\"@bingads-webui-react/layout\":\">=1.2.1\",\"@bingads-webui-react/primitive-unthemed\":\">=1.4.6\",\"@bingads-webui-universal/primitive-utilities\":\">=1.4.2\"},\"devDependencies\":{\"@bingads-webui-react/primitive\":\"file:.\",\"@bingads-webui-react/react-test-setup\":\">=1.0.0\",\"@bingads-webui-test/iframe-driver\":\">=2.1.0\",\"chai\":\"3.5.0\",\"enzyme\":\"3.3.0\",\"jquery\":\"2.2.4\",\"sinon\":\"5.1.1\",\"react-hot-loader\":\"3.1.3\"}}");

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function get() {
    return _layout.Grid;
  }
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _layout.Row;
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _layout.Col;
  }
});
Object.defineProperty(exports, "Form", {
  enumerable: true,
  get: function get() {
    return _layout.Form;
  }
});
Object.defineProperty(exports, "FormGroup", {
  enumerable: true,
  get: function get() {
    return _layout.FormGroup;
  }
});
Object.defineProperty(exports, "ButtonGroup", {
  enumerable: true,
  get: function get() {
    return _layout.ButtonGroup;
  }
});
Object.defineProperty(exports, "ButtonToolbar", {
  enumerable: true,
  get: function get() {
    return _layout.ButtonToolbar;
  }
});
Object.defineProperty(exports, "Panel", {
  enumerable: true,
  get: function get() {
    return _layout.Panel;
  }
});
Object.defineProperty(exports, "PanelGroup", {
  enumerable: true,
  get: function get() {
    return _layout.PanelGroup;
  }
});
exports.Tab = exports.Tabs = exports.Image = exports.NavItem = exports.NavDropdown = exports.Nav = exports.Navbar = exports.Popover = exports.Overlay = exports.OverlayTrigger = exports.Tooltip = exports.Modal = exports.MenuItem = exports.DropdownButton = exports.DropdownMenu = exports.DropdownToggle = exports.Dropdown = exports.Glyphicon = exports.TextArea = exports.Select = exports.Input = exports.Checkbox = exports.Radio = exports.Button = exports.Label = exports.Alert = void 0;

var unthemed = _interopRequireWildcard(__webpack_require__(43));

var _withStyleOverride = __webpack_require__(44);

var _withCustomClassName = __webpack_require__(48);

var _layout = __webpack_require__(50);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

const Alert = (0, _withStyleOverride.withStyleOverride)(unthemed.Alert, ['components.alert']);
exports.Alert = Alert;
const Label = (0, _withStyleOverride.withStyleOverride)(unthemed.Label, ['components.label']);
exports.Label = Label;
const Button = (0, _withStyleOverride.withStyleOverride)(unthemed.Button, ['components.button']);
exports.Button = Button;
const Radio = (0, _withStyleOverride.withStyleOverride)(unthemed.Radio, ['components.radio']);
exports.Radio = Radio;
const Checkbox = (0, _withStyleOverride.withStyleOverride)(unthemed.Checkbox, ['components.checkbox']);
exports.Checkbox = Checkbox;
const Input = (0, _withStyleOverride.withStyleOverride)(unthemed.Input, ['components.input']);
exports.Input = Input;
const Select = (0, _withStyleOverride.withStyleOverride)(unthemed.Select, ['components.select']);
exports.Select = Select;
const TextArea = (0, _withStyleOverride.withStyleOverride)(unthemed.TextArea, ['components.textarea']);
exports.TextArea = TextArea;
const Glyphicon = (0, _withStyleOverride.withStyleOverride)(unthemed.Glyphicon, ['components.glyphicon']);
exports.Glyphicon = Glyphicon;
const Dropdown = (0, _withStyleOverride.withStyleOverride)(unthemed.Dropdown, ['components.dropdown']);
exports.Dropdown = Dropdown;
const DropdownToggle = (0, _withCustomClassName.withCustomClassName)(unthemed.Dropdown.Toggle, 'react-dropdown-toggle', 'toggle');
exports.DropdownToggle = DropdownToggle;
const DropdownMenu = (0, _withCustomClassName.withCustomClassName)(unthemed.Dropdown.Menu, 'react-dropdown-menu', 'menu');
exports.DropdownMenu = DropdownMenu;
const DropdownButton = (0, _withStyleOverride.withStyleOverride)(unthemed.DropdownButton, ['components.dropdownbutton']);
exports.DropdownButton = DropdownButton;
Dropdown.Toggle = DropdownToggle;
Dropdown.Menu = DropdownMenu;
const MenuItem = (0, _withStyleOverride.withStyleOverride)(unthemed.MenuItem, ['components.menuitem']);
exports.MenuItem = MenuItem;
const Modal = (0, _withStyleOverride.withStyleOverride)(unthemed.Modal, ['components.modal']);
exports.Modal = Modal;
const Tooltip = (0, _withStyleOverride.withStyleOverride)(unthemed.Tooltip, ['components.tooltip']);
exports.Tooltip = Tooltip;
const OverlayTrigger = unthemed.OverlayTrigger,
      Overlay = unthemed.Overlay;
exports.Overlay = Overlay;
exports.OverlayTrigger = OverlayTrigger;
const Popover = (0, _withStyleOverride.withStyleOverride)(unthemed.Popover, ['components.popover']);
exports.Popover = Popover;
const Navbar = (0, _withStyleOverride.withStyleOverride)(unthemed.Navbar, ['components.navbar']);
exports.Navbar = Navbar;
const Nav = (0, _withStyleOverride.withStyleOverride)(unthemed.Nav, ['components.nav']);
exports.Nav = Nav;
const NavDropdown = (0, _withCustomClassName.withCustomClassName)((0, _withStyleOverride.withStyleOverride)(unthemed.NavDropdown, ['components.navdropdown']), 'react-dropdown');
exports.NavDropdown = NavDropdown;
const NavItem = (0, _withStyleOverride.withStyleOverride)(unthemed.NavItem, ['components.navitem']);
exports.NavItem = NavItem;
const Image = (0, _withStyleOverride.withStyleOverride)(unthemed.Image, ['components.image']);
exports.Image = Image;
const Tabs = (0, _withStyleOverride.withStyleOverride)(unthemed.Tabs, ['components.tabs']);
exports.Tabs = Tabs;
const Tab = (0, _withStyleOverride.withStyleOverride)(unthemed.Tab, ['components.tab']);
exports.Tab = Tab;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__43__;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStyleOverride = withStyleOverride;

var _underscore = _interopRequireDefault(__webpack_require__(10));

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _reactJss = __webpack_require__(45);

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(46));

var _primitiveUtilities = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const emptyTheme = {};

const styleSheet = _reactJss.jss.createStyleSheet({}).attach();

const getClassName = (theme, fieldName) => {
  const ruleName = fieldName.split('.').pop();
  const elementStyles = (0, _primitiveUtilities.get)(theme, fieldName);
  let rule = styleSheet.getRule(ruleName);

  if (_underscore.default.isEmpty(rule) && !_underscore.default.isEmpty(elementStyles)) {
    rule = styleSheet.addRule(ruleName, elementStyles);
  }

  return (0, _primitiveUtilities.get)(rule, `options.classes.${ruleName}`);
};

function withStyleOverride(Component, fieldNames = []) {
  const StyledComponent = (_ref) => {
    let theme = _ref.theme,
        className = _ref.className,
        forwardRef = _ref.forwardRef,
        props = _objectWithoutProperties(_ref, ["theme", "className", "forwardRef"]);

    const themeClasses = _underscore.default.map(fieldNames, _underscore.default.partial(getClassName, theme));

    const nameProp = (0, _classnames.default)(themeClasses, className);
    return _react.default.createElement(Component, _extends({
      className: _underscore.default.isEmpty(nameProp) ? null : nameProp
    }, props, {
      ref: forwardRef
    }));
  };

  StyledComponent.propTypes = {
    className: _propTypes.default.string,
    theme: _propTypes.default.objectOf(_propTypes.default.object),
    forwardRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
      current: _propTypes.default.any
    })])
  };
  StyledComponent.defaultProps = {
    className: '',
    theme: {},
    forwardRef: null
  };
  const WrappedComponent = (0, _reactJss.withTheme)(StyledComponent);

  const ThemedComponent = _react.default.forwardRef((props, ref) => _react.default.createElement(_reactJss.ThemeProvider, {
    theme: emptyTheme
  }, _react.default.createElement(WrappedComponent, _extends({}, props, {
    forwardRef: ref
  }))));

  (0, _hoistNonReactStatics.default)(ThemedComponent, Component);
  return ThemedComponent;
}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__45__;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__46__;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__47__;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCustomClassName = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(5));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(46));

var _hocUtils = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const withCustomClassName = (WrappedComponent, customClassName, bsRole = '') => {
  const WrappedComponentWithCustomClassName = props => {
    const role = props.bsRole,
          className = props.className,
          forwardedRef = props.forwardedRef,
          rest = _objectWithoutProperties(props, ["bsRole", "className", "forwardedRef"]);

    const nameProp = (0, _classnames.default)(className, customClassName);
    return _react.default.createElement(WrappedComponent, _extends({
      className: nameProp,
      ref: forwardedRef
    }, rest));
  };

  WrappedComponentWithCustomClassName.propTypes = {
    className: _propTypes.default.string,
    forwardedRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
      current: _propTypes.default.instanceOf(Element)
    })]),
    bsRole: _propTypes.default.string.isRequired
  };
  WrappedComponentWithCustomClassName.defaultProps = {
    className: '',
    forwardedRef: null
  };
  WrappedComponentWithCustomClassName.displayName = `withCustomClassName(${(0, _hocUtils.getDisplayName)(WrappedComponent)})`;
  (0, _hoistNonReactStatics.default)(WrappedComponentWithCustomClassName, WrappedComponent);

  const WrappedComponentWithForwardRef = _react.default.forwardRef((props, ref) => _react.default.createElement(WrappedComponentWithCustomClassName, _extends({
    forwardedRef: ref
  }, props)));

  WrappedComponentWithForwardRef.propTypes = {
    bsRole: _propTypes.default.string
  };
  WrappedComponentWithForwardRef.defaultProps = {
    bsRole
  };
  return WrappedComponentWithForwardRef;
};

exports.withCustomClassName = withCustomClassName;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__49__;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__50__;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _underscore = _interopRequireDefault(__webpack_require__(10));

var _controls = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class CheckboxGroup extends _react.default.PureComponent {
  // for now eslint-plugin-react doesn't recognize `getDerivedStateFromProps`
  // which is introduced in React 16.3
  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      name: nextProps.name || prevState.name || _underscore.default.uniqueId('checkbox-group-')
    };
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;
    return _react.default.createElement(_react.default.Fragment, null, this.props.items.map((item, index) => {
      const id = this.props.getItemId(item, index);

      const onChange = event => {
        const checked = event.target.checked ? [...this.props.checked, item] : _underscore.default.without(this.props.checked, item);
        this.props.onChange(checked);
      };

      return _react.default.createElement(_controls.Checkbox, {
        key: id,
        id: `${this.state.name}-${id}`,
        className: this.props.className,
        checked: _underscore.default.contains(this.props.checked, item),
        name: this.state.name,
        onChange: onChange,
        value: getItemValue(item, index)
      }, this.props.renderItem(item, index));
    }));
  }

}

exports.CheckboxGroup = CheckboxGroup;

_defineProperty(CheckboxGroup, "propTypes", {
  checked: _propTypes.default.arrayOf(_propTypes.default.any),
  // eslint-disable-line
  getItemId: _propTypes.default.func,
  getItemValue: _propTypes.default.func,
  items: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  name: _propTypes.default.string,
  // eslint-disable-line
  onChange: _propTypes.default.func.isRequired,
  renderItem: _propTypes.default.func,
  className: _propTypes.default.string
});

_defineProperty(CheckboxGroup, "defaultProps", {
  checked: [],
  getItemId: (item, index) => String(index),
  getItemValue: null,
  name: null,
  renderItem: () => null,
  className: null
});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;

var _react = _interopRequireDefault(__webpack_require__(3));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _underscore = _interopRequireDefault(__webpack_require__(10));

var _controls = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class RadioGroup extends _react.default.PureComponent {
  // for now eslint-plugin-react doesn't recognize `getDerivedStateFromProps`
  // which is introduced in React 16.3
  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      name: nextProps.name || prevState.name || _underscore.default.uniqueId('radio-group-')
    };
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;
    return _react.default.createElement(_react.default.Fragment, null, this.props.items.map((item, index) => {
      const id = this.props.getItemId(item, index);

      const onChange = () => {
        this.props.onChange(item);
      };

      return _react.default.createElement(_controls.Radio, {
        key: id,
        id: `${this.state.name}-${id}`,
        className: this.props.className,
        checked: this.props.checked === item,
        name: this.state.name,
        onChange: onChange,
        value: getItemValue(item, index),
        disabled: this.props.disabled
      }, this.props.renderItem(item, index));
    }));
  }

}

exports.RadioGroup = RadioGroup;

_defineProperty(RadioGroup, "propTypes", {
  checked: _propTypes.default.any,
  // eslint-disable-line
  getItemId: _propTypes.default.func,
  getItemValue: _propTypes.default.func,
  items: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  name: _propTypes.default.string,
  // eslint-disable-line
  onChange: _propTypes.default.func.isRequired,
  renderItem: _propTypes.default.func,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool
});

_defineProperty(RadioGroup, "defaultProps", {
  checked: null,
  getItemId: (item, index) => String(index),
  getItemValue: null,
  name: null,
  renderItem: () => null,
  className: null,
  disabled: false
});

/***/ })
/******/ ])});;
